import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/tier2.gif")